var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-invalid",class:{
        'd-block-options':
            _vm.field.label ==
            'What are you looking for in terms of your investment objective?',
    }},[_c('b-form-group',{staticClass:"kyc-status-radio overwrite-radio",class:{
            'required-field': _vm.field.isRequired || _vm.isRequired,
        },attrs:{"label-for":`id_${_vm.field._id}`}},[_c('label',{class:{
                'urdu-label': _vm.urduLabel,
            }},[_vm._v(_vm._s(_vm.field.label))]),_c('b-form-radio-group',{directives:[{name:"validate",rawName:"v-validate",value:({
                required: _vm.field.isRequired,
            }),expression:"{\n                required: field.isRequired,\n            }"}],class:{
                'is-invalid': _vm.errors.has(_vm.field.label),
            },attrs:{"options":_vm.urduLabel ? _vm.formatOptions() : _vm.field.options,"name":_vm.field._id,"disabled":_vm.loading || _vm.isDisabled || _vm.field.isDisabled,"data-vv-name":_vm.field.label},on:{"input":_vm.checked,"blur":_vm.handleBlur},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }